<template>
    <div v-wechat-title="title" style="height: 100%">
        <crud-facecade
            ref="template-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            :tableHeight="tableHeight"
            dialogWidth="80%"
            :addButton="{ enabled: true, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @loadingEditTemplate="loadingEditTemplate"
        >
            <slot slot="filter">
                <el-col :md="6" :xl="4" class="padding-right10">
                    <item-input type="groupselect" v-model="dic_ward_id" :options="ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
        </crud-facecade>
        <cus-dialog
            ref="form-saveas1"
            :overflow="false"
            :footerVisible="true"
            :okVisible="false"
            :title="currentItem.title"
            :visible.sync="currentItem.visibleSync"
            :close-on-click-modal="false"
            width="70%"
        >
            <cus-form ref="form1" :columns="formColumns" :data="currentItem.data"></cus-form>
            <el-row>
                <el-col class="padding-left20" :span="24">
                    <label for="details" class="el-form-item__label"><span class="item-label">项 目</span></label>
                    <div class="el-form-item__content align-left"></div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="align-right">
                    <ListView :columns="tableColumns" :datalist="currentItem.data.details" :tableHeight="dialogHeight"></ListView>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="currentItem.visibleSync = false">确 定</el-button>
            </div>
        </cus-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `SpecimenTemplates`,
    props: {},
    created() {
        this.loadSpecimenNames()
        this.loadSpecimenTypes()
    },
    data() {
        return {
            title: `标本模板`,
            o_dic_ward_id: undefined,
            issetoperatingward: false,
            hiddenConfirm: true,
            currentItem: {
                visibleSync: false,
                title: `查看`,
                data: {}
            },
            url: {
                baseURL: `api/Nursing/SpecimenTemplate`,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        that.loadTemplates(resolve, reject)
                    })
                },
                getOne: row => {
                    return this.loadOne(row)
                },
                post: row => {
                    return this.saveOne(row, `post`)
                },
                put: row => {
                    return this.saveOne(row, `put`)
                }
            },
            item_configs: [],
            SpecimenTypes: [], // 标本类型
            specimenNames: []
        }
    },
    computed: {
        ...mapGetters([`permissions`, `ward_auth`, `currentUser`, `active_ward`, `sys_enums`, `screenHeight`, `section_auth`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        dialogHeight() {
            return this.screenHeight && (this.screenHeight - 290) || 0
        },
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward) {
                    this.o_dic_ward_id = this.active_ward.value
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.o_dic_ward_id = v
                this.issetoperatingward = true
            }
        },
        formColumns() {
            return [
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isEditable: true,
                    readonly: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isEditable: true,
                    readonly: true,
                    colspan: 6,
                    options: `enum_region_type`
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    isEditable: true,
                    colspan: 6,
                    options: this.ward_auth,
                    readonly: true
                }]
        },
        tableColumns() {
            return [
                {
                    type: `string`,
                    prop: `specimen_name`,
                    label: `标本名称`,
                    readonly: true,
                    isListable: true
                }, {
                    type: `number`,
                    prop: `quantity`,
                    label: `标本数量`,
                    default: 1,
                    readonly: true,
                    isListable: true
                }, {
                    type: `bool`,
                    prop: `is_frozen_section`,
                    label: `冰冻切片`,
                    options: `enum_bool`,
                    readonly: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sampling_position`,
                    label: `取材部位`,
                    readonly: true,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `dic_specimen_type_id`,
                    label: `标本类型`,
                    readonly: true,
                    options: this.SpecimenTypes,
                    isListable: true
                },
                {
                    type: `bool`,
                    prop: `is_soak_section`,
                    label: `是否浸泡`,
                    options: `enum_bool`,
                    readonly: true,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `soak_water`,
                    label: `浸泡液`,
                    isListable: true,
                    options: (that, { row }) => {
                        let data = this.sys_enums.Enum_SoakWater || []
                        var ret = data.map(d => {
                            d.value = d.label
                            return d
                        })
                        return ret
                    },
                    readonly: true
                }
            ]
        },
        columnList() {
            let username = (this.currentUser && this.currentUser.username) || `--`
            var edittmp = this.isHavePermissions(`edit`)
            var deletetmp = this.isHavePermissions(`delete`)
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 6,
                    options: `enum_region_type`,
                    default: 1,
                    change: (that, { row }) => {
                        if (row.region_type == 2) {
                            if (!row.dic_ward_ids) {
                                var ids = []
                                ids.push(this.active_ward.value)
                                row.dic_ward_ids = ids
                            }
                        } else {
                            row.dic_ward_ids = null
                        }
                    }
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 6,
                    options: this.ward_auth,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return (row.region_type === 1)
                        } else {
                            return true
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `creator`,
                    label: `创建人`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `create_date`,
                    label: `创建时间`,
                    width: `140`,
                    isListable: true,
                    sortable: `desc`
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `120`,
                    fixed: `right`,
                    isListable: true,
                    readonly: false,
                    options: function(that, { row }) {
                        if ((username == row.owner && row.region_type == 1) || edittmp || deletetmp) {
                            let rbtn = []
                            if (edittmp) {
                                rbtn.push({
                                    class: `is-plain`,
                                    label: `编辑`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `LoadingUpdateView`,
                                    permission: `default`
                                })
                            }
                            if (deletetmp) {
                                rbtn.push({
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `DeleteData`,
                                    permission: `default`
                                })
                            }
                            return rbtn
                        } else {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `查看`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `loadingEditTemplate`,
                                    permission: `default`
                                }
                            ]
                        }
                    }
                },
                {
                    type: `table`,
                    prop: `details`,
                    label: `项目`,
                    isEditable: true,
                    isCreatable: true,
                    readonly: false,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `id`,
                            isKey: true
                        },
                        {
                            type: `select`,
                            prop: `specimen_name`,
                            label: `标本名称`,
                            isListable: self.specimenNameConfig != `0`,
                            readonly: false,
                            config: {
                                allowCreate: self.specimenNameConfig == `2`
                            },
                            options: this.specimenNames
                        }, {
                            type: `string`,
                            prop: `specimen_name`,
                            label: `标本名称`,
                            readonly: false,
                            isListable: self.specimenNameConfig == `0`
                        }, {
                            type: `number`,
                            prop: `quantity`,
                            label: `标本数量`,
                            default: 1,
                            readonly: false,
                            isListable: true
                        }, {
                            type: `bool`,
                            prop: `is_frozen_section`,
                            label: `冰冻切片`,
                            options: `enum_bool`,
                            default: false,
                            readonly: false,
                            isListable: true
                        },
                        {
                            type: `string`,
                            prop: `sampling_position`,
                            label: `取材部位`,
                            readonly: false,
                            isListable: true
                        },
                        {
                            type: `select`,
                            prop: `dic_specimen_type_id`,
                            label: `标本类型`,
                            readonly: false,
                            options: this.SpecimenTypes,
                            isListable: true
                        },
                        {
                            type: `bool`,
                            prop: `is_soak_section`,
                            label: `是否浸泡`,
                            default: false,
                            options: `enum_bool`,
                            change: (that, { row, index }) => {
                                if (!row.is_soak_section) {
                                    row.soak_water = ``
                                }
                            },
                            readonly: false,
                            isListable: true
                        },
                        {
                            type: `select`,
                            prop: `soak_water`,
                            label: `浸泡液`,
                            isListable: true,
                            options: (that, { row }) => {
                                let data = this.sys_enums.Enum_SoakWater || []
                                var ret = data.map(d => {
                                    d.value = d.label
                                    return d
                                })
                                return ret
                            },
                            readonly: function(that, { row, column, area }) {
                                return !row.is_soak_section
                            }
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        height: this.screenHeight - 300
                    }
                }
            ]
        }
    },
    methods: {
        loadSpecimenNames() {
            let req = this.myaxios.get(`api/Nursing/DicSpecimen/GetSpecimenNames`)
            req.then(data => {
                this.specimenNames = data
            }).catch(e => {
                console.log(e)
                this.specimenNames = []
            })
        },
        loadSpecimenTypes() {
            let req = this.myaxios.get(`/api/AcisSystem/SpecimenType/Get`)
            req.then(data => {
                this.SpecimenTypes = _.map(data, d => {
                    return {
                        label: d.name,
                        value: d.id,
                        disabled: d.is_deleted
                    }
                })
            })
        },
        isHavePermissions(permiskey) {
            return this.permissions && this.permissions.findIndex(item => item.permission === `specimen_template:${permiskey}`) != -1
        },
        loadingEditTemplate({ row }) {
            this.loadOne(row)
                .then(data => {
                    let r = { ...data }
                    this.currentItem.visibleSync = true
                    r.title = `查看`
                    this.currentItem.data = r
                    console.log(`查看查看`)
                    console.log(this.currentItem.data)
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadTemplates(resolve, reject) {
            let that = this

            let req1 = that.myaxios.get(`api/Nursing/SpecimenTemplate/Get`)
            req1.then((data) => {
                data = _.filter(data, d => {
                    let allRegionValue = []
                    _.map(that.ward_auth, d => {
                        allRegionValue.push(d.value)
                    })
                    let owids = (d.dic_operating_ward_id && d.dic_operating_ward_id != `` && d.dic_operating_ward_id.split(`,`)) || []
                    let hasow =
                                _.filter(owids, c => {
                                    return _.includes(allRegionValue, `ow_${c}`)
                                }) || []
                    let rwids = (d.dic_recovery_ward_id && d.dic_recovery_ward_id != `` && d.dic_recovery_ward_id.split(`,`)) || []
                    let hasrw =
                                _.filter(rwids, c => {
                                    return _.includes(allRegionValue, `rw_${c}`)
                                }) || []
                    return (d.region_type == 2 && (hasow.length > 0 || hasrw.length > 0)) ||
                            (d.region_type == 1)
                })

                _.map(data, d => {
                    let owards = d.dic_operating_ward_id && _.split(d.dic_operating_ward_id, `,`).map(p => {
                        p = `ow_${p}`
                        return p
                    }) || []
                    let rwards = d.dic_recovery_ward_id && _.split(d.dic_recovery_ward_id, `,`).map(p => {
                        p = `rw_${p}`
                        return p
                    }) || []
                    let wards = owards.concat(rwards)
                    d.dic_ward_ids = wards
                })
                if (that.dic_ward_id) {
                    data = _.filter(data, r => {
                        return _.includes(r.dic_ward_ids, that.dic_ward_id) || r.region_type == 1
                    })
                }
                resolve(data)
            })
        },
        loadOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`api/Nursing/SpecimenTemplate/Get/${row.id}`)
                req.then(data => {
                    let owards = data.dic_operating_ward_id && _.split(data.dic_operating_ward_id, `,`).map(p => {
                        p = `ow_${p}`
                        return p
                    }) || []
                    let rwards = data.dic_recovery_ward_id && _.split(data.dic_recovery_ward_id, `,`).map(p => {
                        p = `rw_${p}`
                        return p
                    }) || []
                    let wards = owards.concat(rwards)
                    data.dic_ward_ids = wards
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        saveOne(row, tp) {
            return new Promise((resolve, reject) => {
                if (row.region_type == 2 && (!row.dic_ward_ids || row.dic_ward_ids == ``)) {
                    this.$message.error(`请选择可用区域！`)
                    return
                }
                if (!row.details || row.details.length == 0) {
                    this.$message.error(`请录入标本信息！`)
                    return
                }
                try {
                    row.details.forEach(d => {
                        if (!d.specimen_name) {
                            this.$message.error(`请录入标本名称！`)
                            throw new Error(`EndIterative`)
                        }
                    })
                } catch (e) {
                    if (e.message != `EndIterative`) throw e
                    return
                }

                let owItems = _.filter(row.dic_ward_ids, d => _.startsWith(d, `ow_`)).map(d => {
                    d = d.substr(3)
                    return d
                })
                let rwItems = _.filter(row.dic_ward_ids, d => _.startsWith(d, `rw_`)).map(d => {
                    d = d.substr(3)
                    return d
                })
                row.details = row.details && _.map(row.details, d => {
                    d.display_order = d.___sequence_no
                    return d
                }) || []
                let req = this.myaxios[tp](`api/Nursing/SpecimenTemplate/${tp}`, {
                    id: row.id,
                    name: row.name,
                    region_type: row.region_type,
                    dic_operating_ward_id: row.region_type == 1 ? `` : _.join(owItems, `,`),
                    dic_recovery_ward_id: row.region_type == 1 ? `` : _.join(rwItems, `,`),
                    details: row.details
                })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        ReloadListData() {
            let that = this
            that.$refs[`template-list`].ReloadListData()
        }
    },
    watch: {
        dic_ward_id: function() {
            this.ReloadListData()
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Specimen/SpecimenTemplates.vue